import { Form, Formik } from 'formik';
import * as bd from 'react-basic-design';
import { Link, useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import { useAccount } from '../../../app/account-context';
import SvgArrowRight from '../../../assets/icons/ArrowRight';
import { T } from '../../../components/basic/text';
import { FormikTextField } from '../../../components/formik/formik-text-field';
import { SectionTitle } from '../../../components/ui/section-title';
import { TProvider } from '../../../i18n';
import { notify } from '../../../components/basic/notify';
import { CSSProperties, useState } from 'react';
import { LoadingButton } from '../../../components/loading-button';

export const LoginApp = () => {
    const navigate = useNavigate();
    const account = useAccount();
    const [loading, setLoading] = useState<boolean>(false);

    const submitLogin = (values: any) => {
        setLoading(true);
        account
            .login(values.userName, values.password)
            .then(() => navigate('/home', { replace: true }))
            .catch(notify.error)
            .finally(() => setLoading(false));
    };

    const parent_style: CSSProperties = { maxWidth: 500 };
    const child_style: CSSProperties = { maxWidth: 500, borderRadius: 9 };
    const initialValues = { userName: '', password: '' };
    return (
        <TProvider>
            <div className="container-fluid pb-6 mt-5" style={parent_style}>
                <bd.Paper className="mx-auto border shadow-3 overflow-hidden" style={child_style}>
                    <SectionTitle
                        title="login"
                        className="p-3 mb-3 h-auto bg-shell"
                        titleTextColor="text-white"
                    />

                    <Formik
                        initialValues={initialValues}
                        validationSchema={yup.object({
                            userName: yup.string().required(' '),
                            password: yup.string().required(' '),
                        })}
                        onSubmit={submitLogin}
                    >
                        {formik => (
                            <Form>
                                <div className="px-3 pb-3">
                                    <FormikTextField
                                        label={<T>user-name</T>}
                                        name="userName"
                                        labelWidth={4}
                                        inputClassName="ltr"
                                        maxLength={50}
                                        handleEnter
                                        autoFocus
                                    />

                                    <FormikTextField
                                        labelWidth={4}
                                        label="password"
                                        name="password"
                                        autoComplete="off"
                                        maxLength={50}
                                        inputClassName="ltr"
                                        type="password"
                                        handleEnter
                                    />

                                    <div className="p-e-4 mt-4 text-end">
                                        <LoadingButton
                                            icon={<SvgArrowRight />}
                                            loading={loading}
                                            isValid={formik.isValid}
                                            variant="contained"
                                            type="submit"
                                            label={<T>continue</T>}
                                        />
                                    </div>
                                </div>
                                <bd.Flex
                                    className="p-3 border-top small"
                                    align="start"
                                    gap={2}
                                    vertical
                                >
                                    <Link className="text-link" to="/register">
                                        <SvgArrowRight className="rtl-rotate-180" /> <T>register</T>
                                    </Link>
                                </bd.Flex>
                            </Form>
                        )}
                    </Formik>
                </bd.Paper>
            </div>
        </TProvider>
    );
};
